'use client';

import { TextField, TextFieldProps } from '../../';
import { cn } from '../../../libs/utils';
import { Svg } from '../../common';

type DateFormat = 'date' | 'month';

interface DatePickerProps extends Omit<TextFieldProps, 'type' | 'defaultValue' | 'inputMode' | 'trailingElement'> {
  date: Date | undefined;
  isHideIcon?: boolean;
  format?: DateFormat;
}

export const DatePicker = ({ date, onClick, isHideIcon, format = 'date', className, ...props }: DatePickerProps) => {
  const { placeholder, disabled } = props;

  const getDateString = () => {
    if (!date) return '';
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();

    switch (format) {
      case 'month':
        return `${year}년 ${month}월`;
      case 'date':
      default:
        return `${year}년 ${month}월 ${day}일`;
    }
  };

  return (
    <>
      <TextField
        {...props}
        inputMode="none"
        type={'button'}
        className={cn(
          {
            'cursor-pointer': !disabled,
            '*:text-neutral-foreground-low': !!date && disabled,
            '*:!text-neutral-foreground-disabled': !date && placeholder && disabled,
            '*:text-neutral-foreground-lowest': !date && !(placeholder && disabled)
          },
          className
        )}
        onClick={onClick}
        defaultValue={getDateString() || placeholder}
        trailingElement={isHideIcon ? undefined : <Svg src="ic_calendar.svg" width={24} height={24} />}
      />
    </>
  );
};
